// extracted by mini-css-extract-plugin
module.exports = {"country":"CountriesListItem_country__2zquf","inner":"CountriesListItem_inner__3Ny8d","flag":"CountriesListItem_flag__dq8wZ"};